<div class="form-group">
  <mat-label>
    {{ label }}
    @if (!required) {
      <span class="optional-suffix"
        >{{ 'form.optionalSuffix' | transloco }}
      </span>
    }
    @if (faIcon) {
      <fa-icon
        [icon]="faIcon"
        data-boundary="viewport"
        [ngbTooltip]="tooltipMessage"
        [tooltipClass]="'ngb-boels-tooltip'"
        [placement]="'top auto'"
        [autoClose]="'inside'"
        tabindex="0"
        role="button"
      ></fa-icon>
    }
    @if (showDivider) {
      <hr />
    }
  </mat-label>

  @if (additionalLabel) {
    <span class="label-content label-info" [innerHTML]="additionalLabel"></span>
  }

  <textarea
    matInput
    [ngClass]="{ isInvalid: formControl.invalid && formControl.touched }"
    [name]="name"
    [required]="required"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    (ngModelChange)="change($event)"
    [cols]="cols"
    [rows]="rows"
    [maxLength]="maxlength"
    (focus)="limit_hint.onFocus()"
    (blur)="onTouched($event); limit_hint.onBlur()"
  >
  </textarea>
  <boels-limit-hint
    #limit_hint
    class="char_indicator"
    [maxLength]="maxlength"
    [valueLength]="formControl.value?.length"
  ></boels-limit-hint>
  <boels-form-errors
    [control]="formControl"
    [hide]="hideErrors"
  ></boels-form-errors>
</div>
